import { render, staticRenderFns } from "./getTimeElectricshock.vue?vue&type=template&id=3798ea36&scoped=true&"
import script from "./getTimeElectricshock.vue?vue&type=script&lang=js&"
export * from "./getTimeElectricshock.vue?vue&type=script&lang=js&"
import style0 from "./getTimeElectricshock.vue?vue&type=style&index=0&id=3798ea36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3798ea36",
  null
  
)

export default component.exports